import { Hint } from 'features/sentinelDesign/designStyles'
import { FC, useEffect, useState } from 'react'
import styled from 'styled-components'

const Frame = styled.div`
  border: 1px solid ${({ theme }) => theme.forecast.border};
  border-radius: 6px;
  background: ${({ theme }) => theme.forecast.pageBackground1};
  overflow: hidden;

  img {
    display: block;
    width: 100%;
    height: auto;
  }
`

export interface ContextTagPlotProps {
  tag: string
  /** Resolves the plot to an object URL; the route needs an auth header. */
  fetchPlot: (tag: string) => Promise<string | null>
}

/**
 * One tag's composite plot from the context bundle. The plots route is
 * authorized, so the bytes are fetched and handed to `<img>` as an object URL
 * rather than pointed at directly.
 */
export const ContextTagPlot: FC<ContextTagPlotProps> = ({ tag, fetchPlot }) => {
  const [url, setUrl] = useState<string | null>(null)
  const [failed, setFailed] = useState(false)

  useEffect(() => {
    let objectUrl: string | null = null
    let cancelled = false
    setUrl(null)
    setFailed(false)
    void fetchPlot(tag).then((next) => {
      if (cancelled) {
        if (next) URL.revokeObjectURL(next)
        return
      }
      objectUrl = next
      if (next) setUrl(next)
      else setFailed(true)
    })
    return () => {
      cancelled = true
      if (objectUrl) URL.revokeObjectURL(objectUrl)
    }
  }, [tag, fetchPlot])

  if (failed) return <Hint>No plot was rendered for this tag.</Hint>
  if (!url) return <Hint>Loading plot…</Hint>
  return (
    <Frame>
      <img src={url} alt={`Composite plot for ${tag}`} />
    </Frame>
  )
}
